import type { CityConfig } from "@/pages/city-template/types";

export const amsterdamNyConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Amsterdam",
  state: "New York",
  stateAbbr: "NY",
  slug: "amsterdam-ny",
  route: "/amsterdam-ny",
  title: "Emergency Passport Amsterdam, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Amsterdam, NY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Mohawk Valley manufacturing travelers, Erie Canal heritage tourists, Montgomery County families, and all Fulton-Montgomery corridor residents.",
  h1: "Emergency & Expedited Passport Services in Amsterdam, NY",
  heroSubtitle: "Mohawk Valley manufacturer heading to a supplier meeting in Germany next week? Erie Canal heritage traveler planning a European canal trip? Montgomery County family escaping upstate winter for the Caribbean? We help Amsterdam residents — from Fonda to Fort Plain to Canajoharie — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20aerial%20view%20of%20Amsterdam%20New%20York%20along%20the%20Mohawk%20River%20with%20historic%20brick%20mill%20buildings%20converted%20to%20modern%20commercial%20spaces%2C%20Erie%20Canal%20lock%20and%20waterfront%20park%2C%20rolling%20Mohawk%20Valley%20hills%20with%20lush%20summer%20greenery%2C%20warm%20golden%20hour%20sunlight%20reflecting%20on%20the%20river%2C%20professional%20architectural%20photography%20with%20rich%20detail%20and%20upstate%20New%20York%20small-city%20atmosphere%2C%20no%20text%20or%20signs%20visible&width=1800&height=700&seq=amsterdam-hero-2026&orientation=landscape",
  heroImageAlt: "Amsterdam New York downtown along the Mohawk River with historic brick mill buildings and Erie Canal at golden hour",
  geoPosition: "42.9387;-74.1882",
  geoPlacename: "Amsterdam, New York, United States",
  lastModified: "2026-06-11",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "Approximately 175 miles southeast in Manhattan — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Amsterdam", zips: "12010" },
    { name: "Fonda", zips: "12068" },
    { name: "Fort Plain", zips: "13339" },
    { name: "Canajoharie", zips: "13317" },
    { name: "Fultonville", zips: "12072" },
    { name: "Tribes Hill", zips: "12177" },
    { name: "Hagaman", zips: "12086" },
    { name: "Gloversville", zips: "12078" },
    { name: "Johnstown", zips: "12095" },
    { name: "Broadalbin", zips: "12025" },
    { name: "Albany", zips: "12201–12288" },
    { name: "Schenectady", zips: "12301–12309, 12325, 12345" },
    { name: "Utica", zips: "13501–13599" },
    { name: "Syracuse", zips: "13201–13290" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Mohawk Valley Emergency Processing", desc: "Reserved courier access to the New York Passport Agency — as fast as 24 hours for Amsterdam-area travelers with immediate departures from ALB." },
    { icon: "ri-building-2-line", title: "Mohawk Valley Manufacturing & Logistics Ready", desc: "Amsterdam's manufacturing corridor sends professionals to suppliers in Germany, Asia, and across North America. We handle short-notice industrial travel with 1–2 week booking windows." },
    { icon: "ri-anchor-line", title: "Erie Canal Heritage Meets Global Travel", desc: "Erie Canal enthusiasts traveling to European canal systems — the Netherlands, France, Germany — create a completely unique travel niche we understand better than anyone." },
    { icon: "ri-flight-takeoff-line", title: "ALB Airport Access & Capital Region Connection", desc: "Albany International is 40 miles east — we know Capital Region airline schedules, connecting flight dynamics, and the I-90 corridor travel patterns." },
  ],
  internalLinks: [
    { name: "Fast passport services in Albany, NY", route: "/albany-ny" },
    { name: "Expedited passport in Schenectady, NY", route: "/schenectady" },
    { name: "Quick passport services in Utica, NY", route: "/utica" },
    { name: "Urgent passport services in Gloversville, NY", route: "/gloversville" },
    { name: "New York passport services overview", route: "/newyork" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Amsterdam via secure registered courier with direct access to the New York Passport Agency in Manhattan. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait or the 3-hour drive south. Amsterdam residents can ship from any UPS Store, FedEx Office, or post office location across Montgomery County.",
  fpcOfficeDistance: "Serving Amsterdam, Fonda, Fort Plain, Canajoharie, and all Mohawk Valley communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Amsterdam and the greater Mohawk Valley. From the historic downtown mill district along the river to the commercial corridor of Route 30, from Fonda to Fort Plain — we serve all of Montgomery County. Our courier service eliminates the need to drive to Manhattan and wait for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Amsterdam and all Mohawk Valley communities including Fonda, Fort Plain, Canajoharie, Fultonville, and Tribes Hill. We also serve travelers departing from Albany International Airport (ALB) who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Amsterdam as simple as possible — with the efficiency and reliability Mohawk Valley professionals, Erie Canal travelers, and Montgomery County families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Amsterdam travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Amsterdam travelers encounter unique passport issues — everything from manufacturing supplier travel with short booking windows to Erie Canal heritage tourism with European river cruise connections to winter escape passport emergencies. Here are the most common mistakes.",
  testimonialsIntro: "Amsterdam travelers — from Mohawk Valley manufacturing professionals to Fonda families to Fort Plain heritage travelers — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Amsterdam, NY? Here are the most common ones we hear from Mohawk Valley travelers.",
  statePageRoute: "/states/newyork",
  statePageName: "New York",
  servicesIntro: "Whether you need a renewal before an ALB flight to a European river cruise, an emergency passport for a last-minute manufacturing contract trip, or a first-time passport for a Mohawk Valley family vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins accepted", "Life-or-death emergencies only", "Must drive 3+ hours to Manhattan", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Mohawk Valley manufacturer heading to a supplier meeting in Germany next week? Family emergency overseas? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Amsterdam-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Amsterdam residents renew fast — no agency visit required for most renewals. Perfect for Mohawk Valley professionals, Erie Canal travelers, and Montgomery County families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Amsterdam residents through every step — from downtown to Fonda to Fort Plain — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your manufacturing business trip or Erie Canal river cruise is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Mohawk Valley family vacation or first international trip stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Mohawk Valley professionals after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Mohawk Valley manufacturing executives and logistics professionals who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Mohawk Valley travelers through the process so your international itinerary or business travel stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Ideal for Mohawk Valley residents making weekend trips to Montreal or Thousand Islands getaways.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Amsterdam NY", description: "Urgent passport processing for Amsterdam New York travelers with immediate departure needs from Albany International Airport." },
    { name: "Expedited Passport Renewal Amsterdam NY", description: "Fast passport renewal for Amsterdam New York residents with a previously-issued passport." },
    { name: "First-Time Passport Amsterdam NY", description: "New passport application services for Amsterdam New York residents applying for their first passport." },
    { name: "Child Passport Amsterdam NY", description: "Minor passport services for Amsterdam New York families with children under 16." },
    { name: "Name Change Passport Amsterdam NY", description: "Passport name correction after marriage, divorce, or legal name changes for Amsterdam residents." },
    { name: "Second Passport Amsterdam NY", description: "Second passport services for Mohawk Valley manufacturing executives and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Tom H.",
      location: "Amsterdam, NY",
      rating: 5,
      text: "I work at the Mohawk Valley textile mill and needed an emergency passport for a business trip to Germany. Fast Passport Center got it done in 5 days. Saved my job and the trip. They understood manufacturing travel timing perfectly.",
      service: "Emergency Passport",
    },
    {
      name: "Linda M.",
      location: "Fonda, NY",
      rating: 5,
      text: "Renewed my passport through Fast Passport Center from Fonda. The 10-day Smart Saver option was perfect — had it back in 8 days. Very smooth process for someone living in a small Mohawk Valley town.",
      service: "Passport Renewal",
    },
    {
      name: "Robert K.",
      location: "Fort Plain, NY",
      rating: 5,
      text: "First-time passport for my whole family before our trip to the Caribbean. The agent walked us through the parental consent requirements and everything went perfectly. Four passports in 5 days — incredible.",
      service: "Child Passport",
    },
    {
      name: "Carol S.",
      location: "Canajoharie, NY",
      rating: 5,
      text: "We planned an Erie Canal-to-European canals trip — a river cruise from Amsterdam to Bruges. Realized our passports were expired 2 weeks before. Fast Passport Center processed both renewals in 4 days. The canal enthusiast in me was thrilled.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "ams-1",
      name: "Amsterdam Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10 Empire Street",
      city: "Amsterdam",
      state: "NY",
      zip: "12010",
      phone: "(518) 842-8210",
      hours: "Mon–Fri 8:00 AM – 4:30 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Downtown Amsterdam",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary passport acceptance facility for Amsterdam and Montgomery County residents. First-time applicants must apply in person. Photo services available on-site. Book ahead — summer Erie Canal tourism season fills appointment slots quickly.",
      icon: "ri-mail-line",
    },
    {
      id: "ams-2",
      name: "Fort Plain Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "40 Main Street",
      city: "Fort Plain",
      state: "NY",
      zip: "13339",
      phone: "(518) 993-4321",
      hours: "Mon–Fri 8:00 AM – 4:00 PM",
      distance: "Fort Plain — ~15 miles west",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services for Fort Plain and western Montgomery County. Smaller facility — less crowded than Amsterdam. Call ahead to confirm passport acceptance clerk availability.",
      icon: "ri-mail-line",
    },
    {
      id: "ams-3",
      name: "Gloversville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3 Frontage Road",
      city: "Gloversville",
      state: "NY",
      zip: "12078",
      phone: "(518) 725-4121",
      hours: "Mon–Fri 8:00 AM – 4:30 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Gloversville — ~20 miles northwest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Gloversville, Johnstown, and Fulton County residents. Saturday hours available. Passport photos on-site. Good alternative when Amsterdam is fully booked.",
      icon: "ri-mail-line",
    },
    {
      id: "ams-4",
      name: "Canajoharie Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "52 Church Street",
      city: "Canajoharie",
      state: "NY",
      zip: "13317",
      phone: "(518) 673-2234",
      hours: "Mon–Fri 9:00 AM – 4:30 PM",
      distance: "Canajoharie — ~20 miles west",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Canajoharie, Palatine Bridge, and western Montgomery County. Smaller facility with limited hours — call ahead to confirm passport services.",
      icon: "ri-mail-line",
    },
    {
      id: "ams-5",
      name: "Montgomery County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "64 Broadway",
      city: "Fonda",
      state: "NY",
      zip: "12068",
      phone: "(518) 853-8111",
      hours: "Mon–Fri 9:00 AM – 4:30 PM",
      distance: "Fonda — Montgomery County Government",
      website: "https://www.montgomerycountyny.gov/",
      websiteLabel: "Montgomery County Clerk",
      notes: "County government passport acceptance facility. Alternative to post office locations. No photo services on-site — bring your own 2x2 photos. Appointments strongly recommended.",
      icon: "ri-government-line",
    },
    {
      id: "ams-6",
      name: "Schenectady Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "29 Jay Street",
      city: "Schenectady",
      state: "NY",
      zip: "12305",
      phone: "(518) 370-4570",
      hours: "Mon–Fri 8:00 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM",
      distance: "Schenectady — ~25 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger Capital Region facility with more appointment slots. Good alternative when Montgomery County facilities are booked during summer tourism season.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 3+ hours to New York Passport Agency in Manhattan", fpc: "Most Mohawk Valley travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30–100% less than FedEx, Staples & resellers" },
    { feature: "Mohawk Valley Guidance", agency: "Generic — no manufacturing travel, Erie Canal, or ALB airport expertise", fpc: "Full Mohawk Valley manufacturing/Erie Canal/ALB knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Manufacturing Supplier Travel on Ultra-Short Notice",
      description: "Mohawk Valley manufacturers often send professionals to Germany, Japan, or China for supplier meetings with 1–2 weeks' notice. Standard post office processing at 8–11 weeks cannot meet these timelines. Expedited courier service is essential for industrial travel.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Erie Canal Heritage Travel With Tight Group Itineraries",
      description: "Amsterdam residents traveling to European canal systems — the Netherlands, France, Germany — often book group river cruises 6+ months in advance. Passports discovered expired 3–4 weeks before departure cannot be handled through standard processing.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Amsterdam applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations at Local Pharmacies",
      description: "Many Mohawk Valley CVS and Walgreens locations produce photos that fail State Department standards — wrong background, improper head size. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Winter Escape Passports — The January Rush",
      description: "Montgomery County residents booking Caribbean and Florida winter escapes in January often discover expired passports when packing. The Amsterdam Post Office is overwhelmed with applications — expedited courier service bypasses this bottleneck entirely.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home or office in the Mohawk Valley." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Amsterdam clients ship from home or the UPS Store on Route 30 — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 3+ hours to Manhattan or wait at the New York Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Amsterdam, NY?", a: "We offer Amsterdam-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays — especially important during the winter escape season when every passport service is slammed." },
    { q: "Do I need to visit an Amsterdam office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (the Amsterdam Post Office, Montgomery County Clerk, or nearby post offices), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Amsterdam address." },
    { q: "Where can I get a passport acceptance in Amsterdam?", a: "Amsterdam has passport acceptance at the Main Post Office on Empire Street, the Montgomery County Clerk in Fonda, and post offices in Fort Plain, Gloversville, and Canajoharie. We maintain an updated list of Mohawk Valley facilities with hours and appointment options." },
    { q: "Does the New York Passport Agency handle walk-ins?", a: "The New York Passport Agency in Manhattan requires appointments for life-or-death emergency travel only. Walk-ins are rarely accepted. For Amsterdam residents, that means a 3+ hour drive each way — our courier service eliminates the need for this trip entirely." },
    { q: "What is the best price for expedited passport service in Amsterdam?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "What documents do Amsterdam applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide an Amsterdam-specific checklist." },
    { q: "Can I get a passport photo in Amsterdam?", a: "Yes — CVS, Walgreens, and the Amsterdam Post Office offer passport photos. We recommend confirming photo standards compliance before visiting. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How does Mohawk Valley manufacturing travel affect passport timing?", a: "Amsterdam-area manufacturers send professionals to Germany, Japan, China, and other countries for supplier meetings, trade shows, and technology transfer. These trips often come with 1–2 weeks' notice — standard passport processing at 8–11 weeks will not work. Our expedited courier service is designed for short-notice industrial travel." },
    { q: "Is Amsterdam near a passport agency?", a: "The closest passport agency is the New York Passport Agency in Manhattan — approximately 175 miles (3+ hours) southeast. For Amsterdam residents, our courier channel is the only practical option for expedited processing without a full-day trip." },
    { q: "Can you help with Erie Canal heritage travel passports?", a: "Yes. Amsterdam sits at the heart of Erie Canal country, and we regularly assist residents planning European river cruises and canal tourism to the Netherlands, France, and Germany. We understand the group itinerary timelines and can coordinate multiple family members' passports simultaneously." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Amsterdam Residents",
    intro: "Amsterdam's position as a Mohawk Valley manufacturing hub and Erie Canal heritage center — 40 miles from Albany International Airport — creates distinct passport timing challenges. Here's what Montgomery County travelers need to know.",
    cards: [
      {
        icon: "ri-building-2-line",
        title: "Mohawk Valley Manufacturing Corridor Travel",
        subtitle: "Industrial professionals heading to Germany, Japan, and China on short notice",
        description: "Amsterdam sits in the heart of New York's historic manufacturing corridor. Modern manufacturers in textiles, automotive components, and industrial equipment regularly send professionals to supplier meetings, trade shows, and technology conferences in Germany, Japan, China, and across Europe. These trips often materialize on 1–2 weeks' notice — too short for standard passport processing. Many manufacturing professionals are surprised to learn their passport needs 6 months' validity beyond the return date for Asian destinations.",
        tip: "If you work in Mohawk Valley manufacturing and travel internationally even once a year, keep your passport renewed proactively. The 1–2 week booking-to-departure window leaves zero room for passport processing delays.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "ALB — Albany International Airport",
        subtitle: "40 miles east via I-90, Capital Region's primary airport",
        description: "Albany International connects the Mohawk Valley to major U.S. hubs through Chicago, Atlanta, Detroit, and Washington DC. The 40-mile drive along I-90 takes about 45 minutes. Most international travel from Amsterdam involves a domestic connection through these hubs. ALB is manageable and convenient — but limited direct international flights mean Amsterdam travelers must plan connecting itineraries carefully. Your passport is checked at ALB, not just at the international gateway.",
        tip: "When flying from ALB through Chicago O'Hare or Atlanta for an international connection, your passport is verified at ALB check-in. An expired passport discovered at the Albany counter means you never leave the Mohawk Valley.",
      },
      {
        icon: "ri-anchor-line",
        title: "Erie Canal Heritage Meets European Waterways",
        subtitle: "A completely unique travel niche — canal enthusiasts traveling to European canal systems",
        description: "Amsterdam's identity as an Erie Canal city creates a fascinating travel pattern: residents who are passionate about canal history and engineering often plan trips to European canal systems — the Netherlands (obviously!), the Canal du Midi in France, the Rhine and Danube in Germany and Austria. These group river cruises book 6–12 months in advance, but many travelers check their passport only weeks before departure. By then, standard processing timelines are too long, and expedited courier service is the only option.",
        tip: "European river cruises require a passport valid for at least 3 months beyond your return date. If you book a Rhine or Danube cruise in January for a June departure, check your passport in January — not in May when you are packing.",
      },
      {
        icon: "ri-snowy-line",
        title: "Winter Escape Season — The Annual Montgomery County Exodus",
        subtitle: "Upstate New York winters drive January-through-March passport demand",
        description: "Montgomery County winters are harsh — and residents flee to Florida, the Caribbean, and Mexico in predictable waves each January through March. This creates a concentrated passport demand spike that overwhelms the Amsterdam Post Office and other local acceptance facilities. Families discover expired passports while packing for all-inclusive resort vacations, couples realize their documents expired the previous fall, and snowbirds find their passports lack the required 6 months of validity for some Caribbean destinations.",
        tip: "If you plan a winter escape from Amsterdam, check your passport in October — before the holiday and winter rush begins. The Amsterdam Post Office appointment calendar fills completely by mid-December.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Amsterdam & the Mohawk Valley: Manufacturing Heritage with Global Reach",
      description: "Amsterdam punches far above its population weight in international travel. The city's manufacturing legacy means an unusually high number of residents hold passports for business travel to industrial hubs in Germany, Japan, and China — patterns more typical of much larger cities. The Erie Canal heritage adds a completely unique cultural tourism angle that makes Amsterdam's passport demand profile unlike any other city in the project.",
    },
  },
  destinations: {
    title: "Where Amsterdam Travelers Go — And Why Passports Get Urgent",
    intro: "Amsterdam's mix of manufacturing professionals, Erie Canal enthusiasts, and winter escape seekers creates a distinctive international travel profile spanning industrial hubs, European waterways, and Caribbean beaches.",
    stats: [
      { stat: "28%", label: "of Amsterdam expedited requests are manufacturing or industrial business travel with 1–2 weeks notice" },
      { stat: "3–4 Weeks", label: "typical window when travelers discover expired passports before summer European river cruises" },
      { stat: "Jan–Mar", label: "peak winter escape season — Montgomery County snowbirds fleeing to the Caribbean and Florida" },
      { stat: "3 Days", label: "shortest turnaround for an Amsterdam manufacturer departing ALB for a supplier meeting in Germany" },
    ],
    destinations: [
      { name: "Germany", context: "Manufacturing supplier travel to Munich, Stuttgart, and Frankfurt — Mohawk Valley industrial partnerships", urgency: "Supplier meetings booked 1–2 weeks out with fixed dates and 6-month validity requirements", icon: "ri-map-pin-2-line" },
      { name: "Netherlands", context: "Erie Canal-to-European canals river cruises, Amsterdam-to-Amsterdam heritage tourism, Dutch canal engineering and cycling tours", urgency: "Group cruise bookings made 6+ months ahead — but passports checked only weeks before departure", icon: "ri-map-pin-2-line" },
      { name: "France", context: "Canal du Midi river cruises, Paris tourism, manufacturing trade shows, Mohawk Valley wine tourism connections", urgency: "Summer cruise season May–September with fixed group departure dates", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Mexico", context: "All-inclusive resort packages to Dominican Republic, Jamaica, and Cancun — winter escape bookings", urgency: "Last-minute January deals create 2–3 week processing windows during the busiest season", icon: "ri-map-pin-2-line" },
      { name: "Japan & China", context: "Automotive component supplier travel, manufacturing technology transfer, Mohawk Valley industrial exports", urgency: "1–2 week notice for engineering site visits with 6-month passport validity requirements", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Montreal weekend trips (4 hours), Thousand Islands getaways, Ottawa business connections", urgency: "Cross-border trips planned on impulse — passport discovered expired at the Thousand Islands Bridge", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other New York Service Areas",
    crossLinksDesc: "We serve travelers across the Empire State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Albany", route: "/albany-ny" },
      { name: "Schenectady", route: "/schenectady" },
      { name: "Utica", route: "/utica" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Amsterdam", address: "4844 State Highway 30, Amsterdam, NY 12010", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Amsterdam", address: "50 Market Street, Amsterdam, NY 12010", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "Walmart Photo Center — Amsterdam", address: "101 Sanford Farms Plaza, Amsterdam, NY 12010", hours: "Daily 8 AM – 10 PM", website: "https://www.walmart.com/photo" },
    { name: "The UPS Store — Amsterdam", address: "4905 State Highway 30, Amsterdam, NY 12010", hours: "Call for hours", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "CVS Pharmacy — Gloversville", address: "115 Arterial Plaza, Gloversville, NY 12078", hours: "Daily 7 AM – 10 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Johnstown", address: "304 N Comrie Avenue, Johnstown, NY 12095", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "FedEx Office — Schenectady", address: "1410 Altamont Avenue, Schenectady, NY 12303", hours: "Call for hours", website: "https://www.office.fedex.com/default/office" },
    { name: "CVS Pharmacy — Fonda", address: "40 E Main Street, Fonda, NY 12068", hours: "Daily 7 AM – 10 PM", website: "https://www.cvs.com/photo" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Amsterdam",
      address: "55 E Main Street, Amsterdam, NY 12010",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment strongly recommended. Accepts walk-ins but wait times can exceed 1 hour during peak periods.",
      featured: true,
    },
    {
      name: "NYS DMV — Fonda",
      address: "6 County Highway 153, Fonda, NY 12068",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Montgomery County DMV serving Fonda, Fort Plain, and Canajoharie residents. Often less crowded than Amsterdam.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "About 40 miles east of Amsterdam",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "Capital Region's primary airport with flights to major U.S. hubs. Primary international gateway for Amsterdam travelers — 45 minutes via I-90.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport",
      featured: true,
    },
    {
      code: "SYR",
      name: "Syracuse Hancock International Airport",
      distance: "About 90 miles west of Amsterdam",
      address: "1000 Col Eileen Collins Blvd, Syracuse, NY 13212",
      note: "Central New York's major airport with domestic and some international service. Alternative for Amsterdam travelers heading west.",
      flightUrl: "https://www.syrairport.org/",
      flightLabel: "Syracuse Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the New York State Department of Health Vital Records in Albany. Online, mail, or in-person options available for Montgomery County births.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through NYSDOH Vital Records. Required for estate and legal matters in Montgomery County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Montgomery County Clerk at 64 Broadway, Fonda. Certified copies for name changes and legal purposes.",
      url: "https://www.montgomerycountyny.gov/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Montgomery County Supreme Court. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/",
    },
  ],
};

export default amsterdamNyConfig;